import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

const SelectTopicButton = styled(Button)<{ $isSelected?: boolean }>`
  border-radius: 50px;
  padding: ${getSpacing("2x", "2x")};
  margin-right: ${getSpacing("2x")};
  margin-bottom: ${getSpacing("2x")};
  width: fit-content;
  cursor: pointer;

  &,
  &:hover {
    ${(props) =>
      props.$isSelected
        ? css`
            border: 1px solid ${Core.border.default};
          `
        : css`
            border: 1px solid ${Core.border.muted};
          `}
    background-color: ${Core.surface.inverse};
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    &:hover {
      border: 1px solid ${Core.border.muted};
      background-color: ${Core.surface.subdued};
    }
  }

  &:active,
  &:focus {
    border: 1px solid ${Core.border.default};
    background-color: ${Core.surface.inverse};
  }
`;

export const LinkedSingleHelpCenterButtonWrapper = styled(SelectTopicButton)`
  margin: 0;
  &,
  &:hover {
    background-color: inherit;
    border: 1px solid ${Core.border.muted};
  }
`;

export const LinkedHelpCenterButtonWrapper = styled(Row).attrs({
  align: "center",
})`
  margin-top: ${getSpacing("1x")};
  cursor: pointer;
  &,
  &:hover {
    background-color: ${Core.surface.inverse};
  }
  p {
    color: ${Core.text.default} !important;
  }
`;
